<template>
	<div class="content-i">
		<div class="content-box" style="padding-bottom: 0px;">
			<div class="element-wrapper" style="padding-bottom: 0px;">
				<h6 class="element-header">{{ t('titleEditEmailNotifications','titleEditEmailNotifications') }}</h6>
				<div class="element-box">
					<div class="element-info">
						<div class="row">
							<div class="col-12 col-sm-6 col-md-8">
								<div class="element-info-with-icon">
									<div class="element-info-icon">
										<span class="os-icon os-icon-search2"></span>
									</div>
									<div class="element-info-text">
										<h5 class="element-inner-header">{{ t('headerEditEmailNotificationsSearch','headerEditEmailNotificationsSearch') }}</h5>
										<div class="element-inner-desc">{{ t('editEmailNotificationsFormDesc', 'editEmailNotificationsFormDesc') }}</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-sm-3 col-md-4">
								<i id="endUsersSearchToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
							</div>
						</div>
					</div>
					<b-collapse id="search" visible>
						<form v-on:submit.prevent="getEmailNotificationTranslationList">
							<div class="row">
								<div class="col-6">
									<div class="row">
										<div class="col-6">
											<div class="row block-input-row">
												<div class="col-6">
													<span>{{ t('emailNotificationsWordContains', 'emailNotificationsWordContains') }}</span>
												</div>
												<div class="col-6">
													<input class="form-control" v-model="emailNotificationListRequest.notification" type="text">
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-6">
											<div class="row block-input-row">
												<div class="col-6">
													<span>{{ t('emailNotificationsStringIdentifier', 'emailNotificationsStringIdentifier') }}</span>
												</div>
												<div class="col-6">
													<input class="form-control" v-model="emailNotificationListRequest.stringId" type="text">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12 text-right">
									<button v-if="!isBusy" class="btn btn-primary" type="submit" >{{ t('searchEmailNotificationsBtn','searchEmailNotificationsBtn') }}</button>
									<b-button v-else variant="primary" disabled>
										<b-spinner small type="grow"></b-spinner>
										{{ t('searchEmailNotificationsBtn','searchEmailNotificationsBtn') }}
									</b-button>
								</div>
							</div>
						</form>
					</b-collapse>
				</div>
			</div>
		</div>
		<div style="padding-left: 30px; padding-right: 30px">
			<transition name="fade">
				<ResponseInfo v-if="getResponseInfo.responseName == 'manageEmailNotifications'" class="mt-2"/>
			</transition>
		</div>
		<div class="content-box" style="padding-top: 10px;">
			<div class="element-wrapper">
				<div class="element-box">
					<div class="row p-0">
						<div class="col mb-md-0" style="max-width: 160px;">
							<select v-model="language" class="form-control b-2 mr-sm-2 mb-2 mb-md-0" @change="getEmailNotificationTranslationList()">
								<option value="" disabled>{{ t('selectLanguageText','selectLanguageText') }}</option>
								<option v-for="lang in getAllNotificationLanguageList" :key="lang.id" :value="{code: lang.code, name: lang.name}" :selected="lang.code == 'ENG'">{{lang.name}}</option>
							</select>
						</div>
						<button class="btn btn-success" @click="modalCreator({id: 'ModalAddEditEmailNotification', title: t('addEmailNotificationTitle', 'addEmailNotificationTitle'), component: 'addNotification', string_id: null, notification_message: null, languageCode: language.code}, $event.target)">{{ t('addEmailNotification','addEmailNotification') }}</button>
						<b-button v-if="getEmailTrsnalations.length != 0" @click="exportEmailNotificationsCsv" class="ml-2 btn btn-primary">{{ t('emailTranslationsToCSV', 'emailTranslationsToCSV') }}</b-button>
						<b-button v-if="!totalRows && getIsNewsnet" @click="migrateToDynamo" class="ml-2 btn btn-primary">Migrate from mysql to dynamo</b-button>
						<a class="ml-2" style="display: flex; align-items: center;" target="_blank" v-if="downloadUrl" :href="downloadUrl">
							{{ t('downloadEmailNotificationsFileLink', 'downloadEmailNotificationsFileLink') }} ({{ language.code }})
						</a>
					</div>
					<div class="controls-below-table pt-4">
						<div class="col-sm-12 col-md-6 table-records-info" v-if="getEmailTrsnalations.data">
							<p>{{ totalRows }} {{ t('emailTranslationsEntriesFound','emailTranslationsEntriesFound') }}</p>
						</div>
						<div class="col-sm-12 col-md-4" v-if="getEmailTrsnalations.data">
							<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
							</b-pagination>
						</div>
						<div class="col-sm-12 col-md-2">
							<b-input-group class="form-group col-lg-12">
								<b-input-group-prepend>
									<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
								</b-input-group-prepend>
								<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
							</b-input-group>
						</div>
					</div>
					<div class="table-responsive" v-if="getEmailTrsnalations.data && language.code">
						<b-table id="email-notifications-table" striped hover bordered class="mt-3" :busy.sync="isBusy" v-if="getEmailTrsnalations.data" :items="getEmailTrsnalations.data" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :total-rows="totalRows" :per-page="0" :currentPage="currentPage">
							<template v-slot:head(string_id)="data">
								<span >{{ t(data.label, data.label) }}</span>
							</template>
							<template v-slot:head(languageName)="data">
								<span >{{ language.name }}</span>
							</template>
							<template v-slot:head(actions)="data">
								<span >{{ t(data.label, data.label) }}</span>
							</template>
							<template v-slot:cell(stringIdentifier)="data">
								<span>{{data.item.string_id}}</span>
							</template>
							<template v-slot:cell(languageName)="data">
								<b-form-textarea :disabled="true" v-model="data.item[language.code]" class="form-control" rows="5" max-rows="5">
								</b-form-textarea>
							</template>
							<template v-slot:cell(actions)="data">
								<b-link class="px-1" href="#" @click="modalCreator({id: 'ModalAddEditEmailNotification', title: t('editEmailNotificationTitle', 'editEmailNotificationTitle'), component: 'editNotification', string_id: data.item.string_id, notification_message: data.item[language.code], languageCode: language.code}, $event.target)">
									{{ t('emailNotificationsEditBtn', 'emailNotificationsEditBtn') }}
								</b-link>
								<b-link class="px-1" href="#" @click="modalCreator({id: 'ModalClearDeleteEmailNotification', title: t('clearEmailNotificationTitle', 'clearEmailNotificationTitle'), component: 'clearNotification', string_id: data.item.string_id, languageCode: language.code}, $event.target)">
									{{ t('emailNotificationsClearBtn', 'emailNotificationsClearBtn') }}
								</b-link>
								<b-link class="px-1 danger" href="#" @click="modalCreator({id: 'ModalClearDeleteEmailNotification', title: t('deleteEmailNotificationTitle', 'deleteEmailNotificationTitle'), component: 'deleteNotification', string_id: data.item.string_id}, $event.target)">
									{{ t('emailNotificationsDeleteBtn', 'emailNotificationsDeleteBtn') }}
								</b-link>
							</template>
						</b-table>
					</div>
					<div class="controls-below-table pt-4">
						<div class="col-sm-12 col-md-6 table-records-info" v-if="getEmailTrsnalations.data">
							<p>{{ totalRows }} {{ t('emailTranslationsEntriesFound','emailTranslationsEntriesFound') }}</p>
						</div>
						<div class="col-sm-12 col-md-4" v-if="getEmailTrsnalations.data">
							<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
							</b-pagination>
						</div>
						<div class="col-sm-12 col-md-2">
							<b-input-group class="form-group col-lg-12">
								<b-input-group-prepend>
									<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
								</b-input-group-prepend>
								<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
							</b-input-group>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
		<ModalAddEditEmailNotification :modal="this.modal"/>
		<ModalClearDeleteEmailNotification :modal="this.modal"/>
	</div>
</template>

<script>
import { backendUrl } from '@/helpers/backendUrl.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalAddEditEmailNotification from '@/components/Edit_Email_Notifications/ModalAddEditEmailNotification.vue'
import ModalClearDeleteEmailNotification from '@/components/Edit_Email_Notifications/ModalClearDeleteEmailNotification.vue'
import axios from "../axios";

export default {
	name: 'edit_email_notifications',
	data() {
    return {
			isBusy: false,
			currentPage: 1,
			perPage: 20,
			totalRows: 0,
			pageOptions: [10, 20, 50, 100],
			sortBy: null,
			sortDesc: false,
			language: {
				code: null,
				name: null,
			},
			downloadUrl: '',
			activation: '',
			fields: [
				{key: 'string_id', label: 'stringIdentifierLabel', sortable: true, thClass: 'showhand brand-color text-left', tdClass: 'text-left'},
				{key: 'languageName', sortable: true, thClass: 'showhand brand-color text-left', tdClass: 'text-left'},
				{key: 'actions', label: 'actionsLabel', sortable: true, thClass: 'showhand brand-color text-center', tdClass: 'text-center'}
			],
			overlayBackgroundDisplay: false,
			modal: {
        modalData: {},
        updateData: {}
			},
			emailNotificationListRequest: {
				stringId: this.$route.query.stringId ? this.$route.query.stringId : '',
				notification: this.$route.query.notification ? this.$route.query.notification : ''
			},
    }
	},
	components: {
		ResponseInfo,
		ModalAddEditEmailNotification,
		ModalClearDeleteEmailNotification
	},
	provide() {
		return {
			resetModal: this.resetModal
		}
	},
	created(){
		this.getAllLanguages()
		this.getNotificationLanguages()
	},
	methods: {
		getAllLanguages() {
			this.$store.dispatch('getAllLanguageList')
		},
		getEmailNotificationTranslationList() {
			this.isBusy = true
			Object.keys(this.emailNotificationListRequest).forEach((key) => ((this.emailNotificationListRequest[key] == '') || (this.emailNotificationListRequest[key] == null)) && (this.emailNotificationListRequest[key] = undefined))
			this.$router.push({ query: { ...this.$route.query, ...this.emailNotificationListRequest, page: this.currentPage, per_page: this.perPage }})

			this.$store.dispatch('emailNotificationsStore/getEmailNotificationTranslationList', {
				page: this.currentPage,
				per_page: this.perPage,
				langCode: this.language.code,
				stringId: this.emailNotificationListRequest.stringId,
				notification: this.emailNotificationListRequest.notification,
			}).then(() => {
				this.isBusy = false
				this.totalRows = this.getEmailTrsnalations.total
			})
		},
		getNotificationLanguages() {
			this.$store.dispatch('emailNotificationsStore/getNotificationLanguages').then(() => {
				this.language.code = this.getAllNotificationLanguageList[0].code
				this.language.name = this.getAllNotificationLanguageList[0].name
				this.getEmailNotificationTranslationList()
			})
		},
		modalCreator(modalData, button) {
			this.modal.modalData = modalData
			this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
			this.overlayBackgroundDisplay = true
		},
    resetModal(level, button = '') {
      if(level == 'main') {
        Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
				Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
				this.overlayBackgroundDisplay = false
        //this.$store.dispatch('alertClearResponse')
			}
		},
		exportEmailNotificationsCsv() {
			this.$store.dispatch('tokenStore/createDownloadToken', null).then(response => {
				let accessToken = response
				this.downloadUrl = backendUrl() + '/exportEmailNotificationsToCSV/' + this.language.code + '/' + accessToken
			})
		},
    migrateToDynamo() {
      axios().post(`/manageEmailNotifications/migrateToDynamo`)
          .then(res => {
            if (res.data.error.length > 0) {
              alert("Error! Some translations were not migrated!");
              alert(JSON.stringify(res.data.error));
            } else {
              alert("Success! All translations were migrated successfully!");
            }
          });
		}
	},
	computed: {
		...mapGetters(['getAllLanguageList', 'getResponseInfo']),
		...mapGetters('emailNotificationsStore', ['getEmailTrsnalations', 'getAllNotificationLanguageList']),
    ...mapGetters(['getUserDetails', 'getSpinner','getIsNetsendUser','getIsNewsnet','allTemplateDetails']),
	},
  watch: {
    'currentPage'() {
      this.getEmailNotificationTranslationList()
    },
    'perPage'() {
      this.getEmailNotificationTranslationList()
		}
	}
}
</script>

<style scoped>
  #endUsersSearchToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
    cursor: pointer;
  }
  #endUsersSearchToggle.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
  .text-netsend-blue {
    color: #047bf8;
  }
  .block-input-row {
    align-items: center;
    text-align: right;
    margin-top: 5px;
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }

  table >>> tbody, table >>> thead {
    text-align: center;
  }
</style>
